const problems = [
  { icon: 'ri-phone-line', title: 'Missed Calls', desc: 'Calls that never convert because no one was there to answer or follow up.' },
  { icon: 'ri-database-2-line', title: 'Buried Leads', desc: 'Leads lost in disconnected CRMs, spreadsheets, and inboxes with no unified view.' },
  { icon: 'ri-time-line', title: 'Manual Follow-Ups', desc: 'Follow-ups that depend on human memory — and never happen consistently.' },
  { icon: 'ri-eye-off-line', title: 'Zero Visibility', desc: 'No real-time insight into what\'s working, what\'s leaking, or where revenue is lost.' },
];

export default function Problem() {
  return (
    <section id="problem" className="bg-[#07091a] py-24 md:py-32 relative overflow-hidden">
      {/* Subtle grid bg */}
      <div className="absolute inset-0 opacity-5 pointer-events-none"
        style={{ backgroundImage: 'linear-gradient(rgba(139,92,246,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(139,92,246,0.3) 1px, transparent 1px)', backgroundSize: '60px 60px' }}>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        {/* Header */}
        <div className="max-w-3xl mb-16 md:mb-20">
          <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/20 rounded-full px-4 py-1.5 mb-6">
            <span className="w-2 h-2 rounded-full bg-red-400 flex-shrink-0"></span>
            <span className="text-red-300 text-xs font-medium tracking-widest uppercase whitespace-nowrap">The Problem</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
            Your Business Isn't Broken —<br />
            <span className="text-white/40">It's Fragmented.</span>
          </h2>
          <p className="text-white/50 text-base md:text-lg leading-relaxed">
            Most businesses lose revenue in the gaps between tools, teams, and processes. The problem isn't effort — it's architecture.
          </p>
        </div>

        {/* Problem cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
          {problems.map((p, i) => (
            <div
              key={i}
              className="bg-white/3 border border-white/8 rounded-2xl p-6 hover:border-red-500/30 hover:bg-white/5 transition-all group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-red-500/10 border border-red-500/20 mb-4 group-hover:bg-red-500/20 transition-colors">
                <i className={`${p.icon} text-red-400 text-lg`}></i>
              </div>
              <h3 className="text-white font-semibold text-sm mb-2">{p.title}</h3>
              <p className="text-white/40 text-xs leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Bottom statement */}
        <div className="border border-white/8 rounded-2xl bg-white/3 p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center gap-6">
          <div className="flex-1">
            <p className="text-white/70 text-base md:text-lg leading-relaxed">
              You don't need <span className="text-white font-semibold">more tools.</span><br />
              You need a <span className="bg-gradient-to-r from-violet-400 to-indigo-300 bg-clip-text text-transparent font-bold">system.</span>
            </p>
          </div>
          <div className="flex-shrink-0">
            <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br from-violet-500/20 to-indigo-500/20 border border-violet-500/20">
              <i className="ri-links-line text-violet-400 text-2xl"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
